<script lang="ts">
import { useMagicLinkStore } from '@/stores/magic-link'
import { defineComponent, toRef } from 'vue'

export default defineComponent({
  setup() {
    const magicLinkStore = useMagicLinkStore()
    const isProcessing = toRef(magicLinkStore, 'isProcessing')

    return {
      isProcessing,
    }
  },
})
</script>

<template>
  <transition name="fade">
    <div v-if="isProcessing" class="magic-link-overlay" role="status">
      <div class="spinner" aria-hidden="true"></div>
      <span class="sr-only">Signing in</span>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.magic-link-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(21, 26, 49, 0.45);
  z-index: 1600;
}
</style>
